import { Renderer2, Component, OnInit, ViewChild, Injector, ElementRef, ViewContainerRef } from '@angular/core';
import { LayoutService } from '../../../Services/layout/layout.service';
import { BaseComponent } from '../../base.component';
import { isEmpty, orderBy } from 'lodash';
import { ComponentDimensions } from '../../utils/component-dimensions';
import * as bowser from 'bowser';

@Component({
	selector: 'header',
	template: `
		<div class="top-bar" #topbar id="topBar">
			<div class="container customContainer">
				<div class="logo-container">
					<button
						title="Progressive Web Site"
						class="icon icon-logo"
						[ngClass]="{ hoverable: ishover(), 'has-action': logoHasAction }"
						(click)="logoAjaxAction()"
						gtm-handler
						events="click"
						handlerType="button"
						label="ProgressiveLogo"
						action="ButtonClick"
					></button>
					<img class="slash" *ngIf="isFullName" src="assets/images/icons/slash.png" />
					<table class="general-info" *ngIf="isFullName">
						<thead>
							<tr>
								<td>{{ fullName }}</td>
							</tr>
							<tr>
								<td *ngIf="model && globalAttributes.applicationId.value">
									Quote #{{ globalAttributes.applicationId.value }}
								</td>
							</tr>
						</thead>
					</table>
				</div>

				<div class="popups-content" *ngIf="!showPreloader && progressMeter">
					<div class="agents" *ngIf="model && model.metadata.header">
						<div *ngFor="let item of model.metadata.header.agentToolbar" class="agent">
							<div
								class="agent-button-container"
								[tabindex]="item.disabled !== null && item.disabled ? -1 : 0"
								(keydown.enter)="toolBarajaxAction('page', item)"
								[ngClass]="{ disabled: item.disabled !== null && item.disabled }"
							>
								<button
									[ngClass]="{ isAjaxInfo: item.disabled === null || !item.disabled }"
									[attr.name]="item.title"
									[attr.title]="item.tooltip !== null ? item.tooltip : null"
									tabindex="-1"
									(click)="toolBarajaxAction('page', item)"
								>
									{{ item.title }}
								</button>
							</div>
						</div>
					</div>
					<div class="popups" *ngIf="model && model.metadata.header">
						<app-popup
							*ngFor="let popup of model.metadata.header.popups"
							[icon]="popup.icon"
							[title]="popup.title"
							[shortTitle]="popup.shortTitle"
							[href]="popup.href"
							[name]="popup.name"
							[ajaxInfo]="popup.ajaxInfo"
							[gaEventLabel]="popup.attributes && popup.attributes.gaEventLabel ? popup.attributes.gaEventLabel : ''"
						>
						</app-popup>
					</div>
				</div>

				<div class="popups-content" *ngIf="!showPreloader && !progressMeter">
					<div class="agents" *ngIf="model && model.metadata.header">
						<div *ngFor="let item of model.metadata.header.agentToolbar" class="agent">
							<div
								class="agent-button-container"
								[tabindex]="item.disabled !== null && item.disabled ? -1 : 0"
								(keydown.enter)="toolBarajaxAction('page', item)"
								[ngClass]="{ disabled: item.disabled !== null && item.disabled }"
							>
								<button
									[ngClass]="{ isAjaxInfo: item.disabled === null || !item.disabled }"
									[attr.name]="item.title"
									[attr.title]="item.tooltip !== null ? item.tooltip : null"
									tabindex="-1"
									(click)="toolBarajaxAction('page', item)"
								>
									{{ item.title }}
								</button>
							</div>
						</div>
					</div>
					<div class="popups" *ngIf="model && model.metadata.header">
						<app-popup
							*ngFor="let popup of model.metadata.header.popups"
							[icon]="popup.icon"
							[title]="popup.title"
							[shortTitle]="popup.shortTitle"
							[href]="popup.href"
							[name]="popup.name"
							[ajaxInfo]="popup.ajaxInfo"
							[gaEventLabel]="popup.attributes && popup.attributes.gaEventLabel ? popup.attributes.gaEventLabel : ''"
						>
						</app-popup>
					</div>
				</div>

				<!-- For desktop/tablet resolution < 1000px -->

				<!-- Progress Bar < 600 -->
			</div>
			<span *ngIf="model">
				<span
					[hidden]="false"
					*ngIf="model.globalAttributes.errorticket"
					[attr.error-ticket]="globalAttributes.errorticket.value"
				></span>
				<span
					[hidden]="false"
					*ngIf="model.globalAttributes.machineName"
					[attr.machine-name]="globalAttributes.machineName.value"
				></span>
				<span
					[hidden]="false"
					*ngIf="model.globalAttributes.version"
					[attr.version]="globalAttributes.version.value"
				></span>
			</span>
			<div class="floater-container" *ngIf="!isEmptyFloater(floater) && !isMobile && !showPreloader">
				<div class="container">
					<floater [floater]="floater"></floater>
				</div>
			</div>
		</div>
	`,
	styleUrls: ['./header.component.scss'],
})
export class HeaderComponent extends BaseComponent implements OnInit {
	model: data;
	globalAttributes: any;
	progressMeter: any;
	floater: any;
	popups: any;
	logo: logo;
	logoHasAction: boolean;
	isFullName: boolean;
	show = false;
	fullName: any;
	details: any;
	stepDetails: any;
	curntIndex: any;
	curntNexIndex: any;
	curntIndexName: any;
	detlSection: any;
	detlLength: any;
	progressValue: any;
	showPreloader: boolean;
	isshowMyContainer = false;
	menuState = 'out';
	bodyElem = document.querySelector('body');
	@ViewChild('topbar', { static: true, read: ViewContainerRef }) topbar;

	// @HostListener('window:resize', ['$event'])
	// onResize(ev: KeyboardEvent) {
	//  this.setHeadersHeight();
	// }

	constructor(
		injector: Injector,
		private LayoutService: LayoutService,
		private componentDimensions: ComponentDimensions,
		private el: ElementRef,
		private renderer: Renderer2
	) {
		super(injector);
		this.isFullName = false;
		this.isMobile = bowser.getParser(window.navigator.userAgent).getPlatformType() === 'mobile';
	}

	async ngOnInit() {
		this.LayoutService.staticLayout.subscribe((data) => {
			if (data && data.data && data.data.metadata && data.data.metadata.page && data.data.metadata.page.state) {
				this.showPreloader = data.data.metadata.page.state === 'preloader';
				this.model = data.data;
				this.progressMeter = this.model.metadata.progressMeter;

				// Shadow for newprogressbar
				const headerShadow = document.getElementsByTagName('header')[0];

				if (this.showPreloader) {
					// Add mobile class to body
					if (this.isMobile) {
						this.bodyElem.classList.remove('preloader-desktop');
						this.bodyElem.classList.add('preloader-mobile');
					} else {
						this.bodyElem.classList.remove('preloader-mobile');
						this.bodyElem.classList.add('preloader-desktop');
					}

					setTimeout(() => {
						this.setPaddingTop();
					}, 300);
					this.UpdatePreLoaderStyle(this);
				}
			}

			if (data && data.data.metadata.header) {
				this.logo = this.storeService.getState().data.metadata.header.logo;
				this.logoHasAction = !!(this.logo && this.logo.ajaxInfo && this.logo.ajaxInfo.action);

				setTimeout(() => {
					const elmLogo = this.elementRef.nativeElement.querySelector('.icon-logo');
					if (elmLogo && this.logo.url) {
						this.renderer.setAttribute(elmLogo, 'href', this.logo.url);
					}
				}, 300);

				this.model = data.data;
				this.globalAttributes = this.model.globalAttributes;
				this.floater = this.model.metadata.header.floater;
				this.setfullName();

				if (!isEmpty(this.model.metadata.header.agentToolbar)) {
					this.model.metadata.header.agentToolbar = orderBy(this.model.metadata.header.agentToolbar, 'sequence');
				} else {
					this.model.metadata.header.agentToolbar = [];
				}

				setTimeout(() => {
					// this.setHeadersHeight();
					this.setPaddingTop();
				}, 300);
			}
		});

		this.observablesService.showPreloader.subscribe((res: boolean) => {
			this.showPreloader = res;
		});
		const that = this;
		// resize event
		window.onresize = (event) => {
			that.setPaddingTop();
			that.UpdatePreLoaderStyle(that);
		};
	}

	// setHeadersHeight() {
	//  const height = this.el.nativeElement.offsetHeight;
	//  this.componentDimensions.setHeight('header', height);
	// }

	setPaddingTop() {
		const height = this.el.nativeElement.offsetHeight;
		const floaterContainer = this.elementRef.nativeElement.querySelector('.well-container');

		if (floaterContainer) {
			const floaterheight = this.elementRef.nativeElement.querySelector('.floater');
			if (floaterheight) {
				const val = height - floaterheight.offsetHeight;
				this.bodyElem.style.paddingTop = `${val}px`;
			}
		} else {
			this.bodyElem.style.paddingTop = `${height - 1}px`;
		}
	}

	setfullName() {
		if (
			!isEmpty(this.globalAttributes) &&
			!isEmpty(this.globalAttributes.generalInfo) &&
			!isEmpty(this.globalAttributes.generalInfo.fullName)
		) {
			this.isFullName = true;
			this.fullName =
				this.globalAttributes.generalInfo.fullName.length > 100
					? this.globalAttributes.generalInfo.fullName.substring(0, 100)
					: this.globalAttributes.generalInfo.fullName;
		}
	}

	isEmptyFloater(floater) {
		return isEmpty(this.floater);
	}

	logoAjaxAction() {
		if (this.logo) {
			const action = this.logo && this.logo.ajaxInfo ? this.logo.ajaxInfo.action : null;
			const elementSrc = this.logo.name;
			// { { logo && logo.target || '_self' } }

			window.open(this.logo.url || '', this.logo.target || '_self');

			if (action && elementSrc) {
				this.splunkAnalyticsService.publish('LinkClick', action, '');
				return action && this.actionService.ajaxAction(this.logo.ajaxInfo, 'page', elementSrc);
			}
		}
	}

	UpdatePreLoaderStyle(that: any) {
		this.bodyElem.style.overflow = 'initial';
	}

	toolBarajaxAction(context: string, item) {
		if (item.disabled) {
			return;
		}
		this.splunkAnalyticsService.publish('ButtonClick', item.ajaxInfo.action, '');
		return item.ajaxInfo.action && this.actionService.ajaxAction(item.ajaxInfo, context);
	}

	ishover() {
		return this.logo && this.logo.ajaxInfo && this.logo.ajaxInfo.action && this.logo.ajaxInfo.action.length > 0;
	}
}
